<block-ui>
	<app-toast-container aria-live="polite" aria-atomic="true"></app-toast-container>
	<router-outlet></router-outlet>
</block-ui>
